import { useCFPValues } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import {
	Box,
	ComposableTypography,
	InputFieldSizeVariants,
	Link,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';

import { AppSegmentedInput } from '../appSegmentedInput';

const resources = {
	title: 'screens.login.form.sms.title',
	request: {
		counting: 'screens.login.form.sms.request.counting',
		available: 'screens.login.form.sms.request.available',
	},
	button: {
		requestSms: 'screens.login.form.sms.button.requestSms',
	},
};

export interface SmsProps {
	phoneNumber?: string | null;
	value?: string;
	counter?: number;
	onValueChange?: (value: string) => void;
	onLinkClick?: () => void;
}

export const Sms = ({ phoneNumber = '', value = '', counter = 0, onValueChange, onLinkClick }: SmsProps) => {
	const { t } = useTranslation();
	const { getToken, getValue } = useCFPValues();

	const handleSegmentedInputOnChange = (value?: string) => {
		/* only allow numeric characters to be inserted in the input */
		const numericRegex = /^[0-9]+$/;
		if (!value || numericRegex.test(value)) {
			onValueChange?.(value || '');
		}
	};

	return (
		<Box styles={{ flexDirection: 'column', gap: UIHelper.rem(32) }}>
			<ComposableTypography
				baseProps={{
					appearance: getToken({
						default: {
							default: 'body-100-03',
						},
					}),
				}}
				text={t(resources.title, {
					phoneNumber,
				})}
				tags={{}}
			/>

			<Box styles={{ flexDirection: 'column', gap: UIHelper.rem(24) }}>
				<AppSegmentedInput
					size={getValue<InputFieldSizeVariants>({
						default: {
							default: 'xxLarge',
							mobile: 'xxLarge',
							laptop: 'xxxLarge',
						},
					})}
					length={7}
					mask="numeric"
					value={value}
					onChange={handleSegmentedInputOnChange}
				/>

				{counter > 0 ? (
					<ComposableTypography
						baseProps={{
							appearance: getToken({
								default: {
									default: 'body-100-03',
								},
							}),
							colorToken: 'secondary-light',
						}}
						text={t(resources.request.counting, {
							counter: counter.toString(),
						})}
						tags={{
							b: {
								appearance: getToken({
									default: {
										default: 'body-100-04',
									},
								}),
								colorToken: 'secondary-light',
							},
						}}
					/>
				) : (
					<Link label={t(resources.request.available)} onPress={onLinkClick} />
				)}
			</Box>
		</Box>
	);
};
